module.exports = "Group ID,Farm Name,Creation Date,Start Date,Close Date,Farm ID\n"